import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=6ef9eee2&"
import script from "./DashboardManager.vue?vue&type=script&lang=js&"
export * from "./DashboardManager.vue?vue&type=script&lang=js&"
import style0 from "./DashboardManager.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports